// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mr-0";